import { render, staticRenderFns } from "./TopArticlesTable.vue?vue&type=template&id=28657981&scoped=true&"
import script from "./TopArticlesTable.vue?vue&type=script&lang=js&"
export * from "./TopArticlesTable.vue?vue&type=script&lang=js&"
import style0 from "./TopArticlesTable.vue?vue&type=style&index=0&id=28657981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28657981",
  null
  
)

export default component.exports